import { useEffect } from "react";
import BaseLayout from "layouts/sections/components/BaseLayout";
import MKBox from "components/MKBox";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

import bgImage from "assets/images/fondo-consumibles.png";
import imagenBeneficios from "assets/images/beneficios-suministros.png";
import imagenProteccion from "assets/images/Carrusel TO - 1.png";
import imagenToner from "assets/images/Carrusel TO - 2.png";
import imagenTonerDetalle from "assets/images/Carrusel TO - 3.png";
import imagenTecnico from "assets/images/Carrusel TO - 4.png";

import {
  DropletsIcon,
  PackageIcon,
  LayersIcon,
  BuildingIcon,
  TruckIcon,
  ActivityIcon,
  HeadsetIcon,
  FileCheckIcon,
  SlidersIcon,
  ShieldCheckIcon,
  WrenchIcon,
  LockIcon,
  CalculatorIcon,
  CircleDollarIcon,
  FileXIcon,
  TrendingDownIcon,
  RecycleIcon,
  RefreshIcon,
  TrashIcon,
  LeafIcon,
  BadgeCheckIcon,
  PackageCheckIcon,
  ArrowRightIcon,
} from "components/KinitechLanding/icons";
import FeatureCarousel from "components/KinitechLanding/FeatureCarousel";
import QuoteSection from "components/KinitechLanding/QuoteSection";
import FaqSection from "components/KinitechLanding/FaqSection";
import CtaBand, { StickyCta } from "components/KinitechLanding/CtaBand";
import { scrollToContacto } from "components/KinitechLanding/scroll";
import useScrollReveal from "components/KinitechLanding/useScrollReveal";
import "components/KinitechLanding/styles.css";
import { initTracking } from "tracking";

const description = "Suministros HP originales en Cali";

const heroSlides = [
  {
    eyebrow: "Suministros HP originales en Cali",
    title: "Suministros HP originales e impresión en Cali",
    lead: "Tóner y cartuchos HP originales para impresoras empresariales en Cali. Compatibilidad con equipos HP, calidad de impresión y funcionamiento confiable. Protege tu infraestructura, reduce fallas por consumibles defectuosos y mantén la continuidad operativa de tu empresa.",
    tag: "Protección",
    image: imagenProteccion,
    imageAlt:
      "Multifuncional HP LaserJet y caja de tóner original HP 214A sobre un escritorio en oficina",
    features: [
      {
        icon: ShieldCheckIcon,
        title: "Protección de equipos HP",
        text: "Compatibilidad y confiabilidad para tus impresoras empresariales.",
      },
      {
        icon: WrenchIcon,
        title: "Menos fallas e interrupciones",
        text: "Reduce los riesgos asociados a consumibles defectuosos y fugas de tóner.",
      },
      {
        icon: FileCheckIcon,
        title: "Calidad de impresión empresarial",
        text: "Textos nítidos y resultados consistentes.",
      },
      {
        icon: LockIcon,
        title: "Seguridad de la cadena de suministro",
        text: "Controles de integridad y medidas contra la manipulación en productos cubiertos por ISO/IEC 20243.",
      },
    ],
  },
  {
    eyebrow: "Optimiza tu presupuesto de impresión",
    title: "Menor costo por página, mayor control de tus gastos",
    lead: "Comprar tóner para empresas no se trata solo de elegir el precio más bajo. Los tóneres alternativos defectuosos pueden generar atascos de papel, reimpresiones, desperdicio de consumibles y mantenimientos correctivos, aumentando el costo total de impresión. Con tóner HP original, contribuye a una impresión empresarial más confiable y a un mejor control de los gastos operativos.",
    tag: "Rentabilidad",
    image: imagenToner,
    imageAlt: "Tóner original HP 147A junto a monedas, calculadora y un informe de costo por página",
    features: [
      {
        icon: CalculatorIcon,
        title: "Control del costo por página",
        text: "Evalúa el rendimiento real del tóner HP original y el costo por página impresa.",
      },
      {
        icon: CircleDollarIcon,
        title: "Menos gastos de mantenimiento",
        text: "Disminuye los riesgos asociados a consumibles defectuosos y reparaciones adicionales de impresoras HP.",
      },
      {
        icon: FileXIcon,
        title: "Menos atascos y desperdicio de papel",
        text: "Reduce el riesgo de impresiones defectuosas, reposición de papel y reimpresiones.",
      },
      {
        icon: TrendingDownIcon,
        title: "Optimización del presupuesto empresarial",
        text: "Controla los costos de impresión, el consumo de tóner y los gastos operativos de tu empresa.",
      },
    ],
  },
  {
    eyebrow: "Impresión responsable para tu empresa",
    title: "Reduce el impacto ambiental de tus consumibles",
    lead: "Integra el suministro de tóner HP original a una estrategia de compras sostenibles. Aprovecha los programas de devolución y reciclaje disponibles para gestionar responsablemente los cartuchos usados y contribuir a una economía circular en tu operación empresarial.",
    tag: "Sostenibilidad",
    image: imagenTonerDetalle,
    imageAlt: "Caja HP Planet Partners con cartuchos de tóner usados para reciclaje",
    features: [
      {
        icon: RecycleIcon,
        title: "Recolección de cartuchos HP",
        text: "Conoce las opciones disponibles mediante HP Planet Partners.",
      },
      {
        icon: RefreshIcon,
        title: "Materiales reciclados",
        text: "HP reutiliza materiales mediante su programa Planet Partners.",
      },
      {
        icon: TrashIcon,
        title: "Gestión responsable de residuos",
        text: "Orienta la disposición de consumibles usados conforme al programa aplicable.",
      },
      {
        icon: LeafIcon,
        title: "Compras sostenibles para empresas",
        text: "Apoya las iniciativas ambientales y los objetivos corporativos de sostenibilidad.",
      },
    ],
  },
  {
    eyebrow: "Tu aliado en suministros HP originales en Cali",
    title: "Canal autorizado HP para suministros originales en Cali",
    lead: "En KINITECH, en Cali, te acompañamos en la compra de tóner HP original y suministros originales para impresión empresarial. Como canal autorizado HP, ofrecemos asesoría especializada, identificación de referencias compatibles y abastecimiento adaptado a tu organización.",
    tag: "Respaldo Kinitech",
    image: imagenTecnico,
    imageAlt: "Asesor de KINITECH sosteniendo una caja de tóner original HP 147A en bodega",
    features: [
      {
        icon: BadgeCheckIcon,
        title: "Canal autorizado HP",
        text: "Confianza en la procedencia y comercialización de productos originales.",
      },
      {
        icon: HeadsetIcon,
        title: "Asesoría especializada",
        text: "Identificación de referencias y necesidades de consumo.",
      },
      {
        icon: PackageCheckIcon,
        title: "Abastecimiento empresarial",
        text: "Planificación de pedidos según el consumo y las condiciones comerciales acordadas.",
      },
      {
        icon: LayersIcon,
        title: "Soluciones integrales de impresión",
        text: "Suministros HP, administración de equipos y servicios de outsourcing de impresión.",
      },
    ],
  },
];

const portfolioCards = [
  {
    icon: DropletsIcon,
    title: "Tóner Original HP",
    text: "Tóner HP original para impresoras y equipos multifuncionales empresariales, con disponibilidad para consumo recurrente.",
  },
  {
    icon: PackageIcon,
    title: "Cartuchos de Tinta HP Originales",
    text: "Cartuchos HP originales para impresoras de oficina y equipos empresariales, con calidad y rendimiento confiables.",
  },
  {
    icon: LayersIcon,
    title: "Consumibles HP para Impresión",
    text: "Suministros y consumibles HP originales para mantener sus impresoras y equipos multifuncionales en óptimas condiciones.",
  },
  {
    icon: BuildingIcon,
    title: "Soluciones HP para empresas",
    text: "Soluciones de abastecimiento de tóner y suministros HP según el volumen de impresión, número de equipos y necesidades de su empresa.",
  },
];

const benefits = [
  {
    icon: TruckIcon,
    title: "Abastecimiento",
    text: "Pedidos programados para evitar quiebres de inventario.",
  },
  {
    icon: ActivityIcon,
    title: "Continuidad operativa",
    text: "Sus equipos siempre disponibles para operar.",
  },
  {
    icon: HeadsetIcon,
    title: "Asesoría",
    text: "Recomendación del suministro correcto por referencia de equipo.",
  },
  {
    icon: BuildingIcon,
    title: "Atención empresarial",
    text: "Ejecutivo de cuenta y condiciones corporativas.",
  },
  {
    icon: FileCheckIcon,
    title: "Facilidad de cotización",
    text: "Respuesta clara y ágil para áreas de compras.",
  },
  {
    icon: SlidersIcon,
    title: "Soluciones según necesidad",
    text: "Ajustadas a su consumo real.",
  },
];

const faqItems = [
  {
    question: "¿Por qué elegir un original por encima del genérico?",
    answer: [
      "El tóner original HP está diseñado específicamente para impresoras HP, ofreciendo calidad, rendimiento y mayor confiabilidad. Además, incorpora tecnologías de seguridad en el chip del cartucho, que ayudan a protegerlo frente a manipulaciones y posibles amenazas.",
      "También puede contribuir a disminuir los costos de mantenimiento: la dispersión de residuos de tóner dentro del equipo puede afectar sus componentes, aumentar los problemas de impresión y generar más atascos de papel, ocasionando paradas y mayores costos operativos.",
      "Un tóner alternativo puede además ofrecer menor rendimiento por cartucho, aumentando la frecuencia de reemplazo y el costo por impresión.",
    ],
  },
  {
    question: "¿Cómo puedo saber si un tóner HP es original?",
    answer: [
      "Los tóner HP originales cuentan con elementos de seguridad en su empaque que permiten verificar su autenticidad. Dependiendo de la versión del empaque, puedes revisar la etiqueta de seguridad holográfica y validar el producto mediante el código QR. HP también recomienda verificar que los sellos y elementos de seguridad del empaque estén intactos. HP",
      "En KINITECH comercializamos suministros HP originales, para que tu empresa pueda contar con consumibles confiables y compatibles con sus equipos.",
    ],
  },
  {
    question: "¿Cómo sé qué tóner HP necesita mi impresora?",
    answer: [
      "Puedes identificar el tóner HP adecuado a partir del modelo de tu impresora o de la referencia del consumible que utilizas actualmente. Si no conoces la referencia, puedes enviarnos el modelo de tu impresora o multifuncional HP y nuestro equipo te ayudará a identificar el tóner original HP compatible.",
    ],
  },
  {
    question:
      "¿Pueden suministrar tóner HP para empresas con consumo recurrente?",
    answer: [
      "Sí. En KINITECH ofrecemos suministro de tóner HP original para empresas de acuerdo con sus necesidades de consumo. Podemos establecer esquemas de abastecimiento programado según el número de equipos, volumen de impresión y frecuencia de consumo, ayudando a reducir el riesgo de quedarse sin suministros.",
    ],
  },
  {
    question: "¿Ofrecen condiciones comerciales para empresas?",
    answer: [
      "Sí. Atendemos empresas que requieren suministros HP originales de manera puntual o recurrente. Analizamos las necesidades de cada organización para presentar una cotización de tóner HP y consumibles de impresión acorde con su operación, volumen y requerimientos de abastecimiento.",
    ],
  },
  {
    question: "¿Cuento con varias sedes, hacen envíos a nivel nacional?",
    answer: [
      "Sí. Atendemos requerimientos empresariales con múltiples sedes y podemos coordinar el envío de suministros HP a diferentes ciudades del país, de acuerdo con las condiciones y cobertura de cada solicitud.",
    ],
  },
  {
    question:
      "¿Realizan envíos de tóner HP a nivel nacional para empresas con varias sedes?",
    answer: [
      "Sí. En KINITECH realizamos envíos de tóner HP original y suministros de impresión a nivel nacional, facilitando el abastecimiento de empresas con una o múltiples sedes. Coordinamos los pedidos de acuerdo con las necesidades de cada organización para ayudar a garantizar la disponibilidad de sus consumibles HP.",
    ],
  },
  {
    question: "¿Qué significan las referencias de tóner HP Tipo A y Tipo X?",
    answer: [
      "Las referencias Tipo A y Tipo X corresponden a diferentes niveles de rendimiento. La referencia Tipo X ofrece un mayor volumen de impresión que la Tipo A, por lo que es una alternativa ideal para empresas con mayores volúmenes de impresión. En KINITECH te asesoramos para elegir el tóner HP original adecuado para tu equipo y necesidades.",
    ],
  },
];

const necesidadOptions = [
  "Tóner Original HP",
  "Cartuchos de Tinta HP",
  "Suministros HP para impresión",
  "Consumibles HP",
  "Tóner para impresora multifuncional HP",
  "Abastecimiento recurrente para empresa",
  "Otro",
];

function CotizarLink({ className = "kn-link", children = "Cotizar" }) {
  return (
    <button type="button" className={className} onClick={scrollToContacto}>
      {children} <ArrowRightIcon />
    </button>
  );
}

function ConsumiblesLandingBody() {
  const revealRef = useScrollReveal();

  useEffect(() => {
    initTracking("consumibles");
  }, []);

  return (
    <div className="kn-landing" ref={revealRef}>
      <FeatureCarousel
        slides={heroSlides}
        label="Suministros y servicios HP para empresas"
      />

      <section className="kn-section">
        <div className="kn-container">
          <div data-reveal="up">
            <span className="kn-eyebrow">Portafolio en Cali</span>
            <h2 className="kn-section-title">
              Suministros HP originales para impresión en Cali
            </h2>
            <p className="kn-section-lead">
              Portafolio de suministros HP originales para empresas en Cali:
              tóner, cartuchos y consumibles para garantizar el abastecimiento
              de su operación de impresión.
            </p>
          </div>
          <div className="kn-cards-grid" data-reveal-group>
            {portfolioCards.map(({ icon: Icon, title, text }) => (
              <article key={title} className="kn-card" data-reveal="flip">
                <span className="kn-icon-chip">
                  <Icon />
                </span>
                <h3>{title}</h3>
                <p>{text}</p>
                <CotizarLink />
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="kn-section kn-section--surface">
        <div className="kn-container kn-benefits-grid">
          <div className="kn-benefits-image" data-reveal="left">
            <img
              src={imagenBeneficios}
              alt="Inventario de tóner y suministros de impresión en bodega corporativa"
            />
          </div>
          <div data-reveal="right">
            <span className="kn-eyebrow">Beneficios</span>
            <h2 className="kn-section-title">
              Un proveedor empresarial, no una tienda de cartuchos
            </h2>
            <p className="kn-section-lead">
              Acompañamos a las áreas de compras, TI y administración con un
              modelo de abastecimiento pensado para la continuidad.
            </p>
            <div className="kn-features" data-reveal-group>
              {benefits.map(({ icon: Icon, title, text }) => (
                <div key={title} className="kn-feature" data-reveal="up">
                  <span className="kn-icon-chip">
                    <Icon />
                  </span>
                  <div>
                    <h4>{title}</h4>
                    <p>{text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CtaBand
        title="Solicite su cotización de suministros HP"
        text="Indíquenos sus referencias o equipos y recibirá una propuesta empresarial."
      />

      <QuoteSection
        eyebrow="Contacto"
        title="Cotice sus suministros HP"
        lead="Complete el formulario y un asesor empresarial de KINITECH le responderá con la propuesta."
        options={necesidadOptions}
        submitLabel="Solicitar cotización"
        subjectPrefix="Cotización suministros HP"
        trackingKey="consumibles"
      />

      <FaqSection items={faqItems} />

      <CtaBand title="¿Necesita una solución para la impresión de su empresa?" />

      <StickyCta />
    </div>
  );
}

const EmptySection = () => null;

function Consumibles() {
  return (
    <>
      <MKBox bgColor="white">
        <BaseLayout
          bgImage={bgImage}
          logoSolution=""
          desc={description}
          cardsComponent={EmptySection}
          soloHeader
          parallax
          whitewash
        />
        <ConsumiblesLandingBody />
      </MKBox>
      <MKBox mt="auto" pt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Consumibles;
